import { FilespaceFormatForMigrations } from '@lucidlink/dto/validation';
import { ArrowCircleBrokenUpRightIcon, translate } from '@lucidlink/uicore';
import { FilespaceCardTestIdFactory } from '@lucidlink/workspacemanagement/interactions';
export const getUpgradeIndicatorContent = (filespace) => {
    return {
        tooltip: [
            translate('Filespace version upgrade available.'),
            translate('Current version: {{currentFilespaceFormat}} Latest version: {{latestFilespaceFormat}}', {
                currentFilespaceFormat: filespace.format,
                latestFilespaceFormat: FilespaceFormatForMigrations,
            }),
            translate('Use the desktop app to upgrade.'),
        ],
        indicator: ArrowCircleBrokenUpRightIcon,
        label: translate('Filespace version upgrade available.'),
        'data-testid': FilespaceCardTestIdFactory.getFilespaceCardUpgradeIconTestId(filespace.id),
    };
};
